import { makeAutoObservable } from 'mobx'
import getCookie from '../utils/utils/getCookieByName'

class WebSocketService {
  constructor() {
    this.connection = null
    this._clientCookie = getCookie('csid')
    this.callbackMap = {}
    this.url = `${window.SAT.config.apiUrl}/ws?access_token=${this._clientCookie}`
    makeAutoObservable(this)
  }

  setConnection = () => {
    this._clientCookie = getCookie('csid')
    this.url = `${window.SAT.config.apiUrl}/ws?access_token=${this._clientCookie}`

    if (this._clientCookie && !this.connection) {
      this.connection = new window.signalR.HubConnectionBuilder()
        .withUrl(`${this.url}`, {
          transport: signalR.HttpTransportType.WebSockets,
          skipNegotiation: true,
        })
        .configureLogging(window.signalR.LogLevel.Information)
        .withAutomaticReconnect([5000, 5000, 5000, 5000])
        .build()

      this.connection.onclose((err) => {
        if (err) {
          setTimeout(this.start, 5000)
        }
      })

      this.connection.onreconnected(() => {
        this._clientCookie = getCookie('.csid')
        this.url = `${window.SAT.config.apiUrl}/ws?access_token=${this._clientCookie}`
        setTimeout(this.start, 5000)
      })
    }

    this.start()

    this.connection.on('Notification', (data) => {
      Object.values(this.callbackMap).forEach((callback) => callback(data))
    })
  }

  start = () => {
    if (this.connection && this.connection?.state !== 'Connected') {
      this.connection
        .start()
        .then(() => {})
        .catch((err) => {
          if (err.message && err.message.includes(`Status code '403'`)) {
            this.disconnect()
          } else {
            this._clientCookie = getCookie('csid')
            this.url = `${window.SAT.config.apiUrl}/ws?access_token=${this._clientCookie}`
            setTimeout(this.start, 5000)
          }
        })
    }
    // }
  }

  disconnect = () => {
    if (this.connection) {
      this.connection.stop()
      this.connection = null
      this._clientCookie = null
    }
  }

  setSubscribe = (key, callback) => {
    this.callbackMap[key] = callback
  }

  // todo изучить вопрос уничтожения сторов и отписаться ото всех событий
  deleteSubscribe = (key) => {
    delete this.callbackMap[key]
  }
}

export default new WebSocketService()
